import React from "react";
import { Carousel } from "react-responsive-carousel";

import Footer from "../../components/footer/Footer";

const data = [
  {
    id: 1,
    img: "/images/gauri (2).jpg",
    name: "Gauri Birari",
    designation: "Front-end Web Developer & Designer",
    desc: " Reflecting on my journey, I am working as a front-end web developer at Innovative Solutions. It's already been a year since I joined here. When I joined here, I started from scratch, but now after 1 year, I am thrilled to be learning outside of my field here. I am pleased to have the chance to create a project from scratch. All my colleagues and especially My Senior raised me so well, and it was my best decision to join this company because I learned things I had never experienced before. I believe this is the turning point of my career, and thanks to all my colleagues and Santosh sir for making me the wonderful person I am today.",
  },
  {
    id: 2,
    img: "/images/gaurav.jpg",
    name: "Gaurav Lonari",
    designation: "Fullstack Web Developer",
    desc: "  I have been working as a Full Stack Developer Intern at The Innovative Solutions for almost 3 months now and I wanted to share my positive experience. The onboarding process, led by Mr. Nilesh was smooth and made it easy for me to contribute to the company's objectives. I have been working on a project from scratch and it is almost ready as a prototype. My colleagues, Ms. Gauri, Ms.Sakshi, have been very collaborative and supportive in this process. Mr. Santosh has ensured that I have a comfortable work environment and access to various facilities for a great work-life balance. The team atmosphere is supportive and positive, which has enabled me to give my best effort. I am grateful for the opportunity and look forward to further growth with The Innovative Solutions.",
  },
  {
    id: 3,
    img: "/images/sakshi.jpeg",
    name: "Sakshi Kadave",
    designation: "Backend Web Developer",
    desc: " I am working as a backend end developer at the Innovative Solutions, and I have been with this company for 1 year now, My experience with this company has been like my second home. All the people around me in the company, especially My Senior, who raised me up in all things that I even had no idea about before my colleagues taught me well, make joining this company the best decision I have ever made.",
  },
  // {
  //   id: 4,
  //   img: kunjal,
  //   name: "Kunjal Pande",
  //   designation: "Front Web Developer (Intern) ",
  //   desc: " My name is Kunjal and I had the opportunity to go through a three-month Web Development internship at 'Innovative Solutions'. I must say this was an enriching experience for me as an intern.Since I got this opportunity, my goal for this short period was to get acquainted with the culture of the software firm, to learn as much as possible about the web development domain, to expand my knowledge, and to gain hands-on experience in projects. I got the opportunity to work as a team lead of interns. At the time of my internship, I gained precious experience, practical skills, and applied knowledge. I want to note the keen team at Innovative Solutions which openly accepts new people and is ready to help atany moment in time, I wish to say special thanks to Mr. Santosh Sir, Ms. Gauri Ma'am, and Sakshi Ma'am for guidance, support, and for their excellent attitude, help, and incredible responsiveness. I will recall these months with the warmest thoughts!",
  // },

  // {
  //   id: 5,
  //   img: manish,
  //   name: "Manish Karegaonkar",
  //   designation: "Front Web Developer (Intern) ",
  //   desc: "I am very glad to tell you about my internship experience at The Innovative Solutions company. It was a great experience of learning and practical implementation of a live project.Currently, I am working as a Full stack web developer intern for the last 3 months got a lot of practical coding experience. I learned many skills like leadership skills, team management, time management, etc while leading my Goda project team. The flounder of our company Mr. Santosh Mundhe sir always guided me to improve my technical as well as soft skills and also directed me to correct track. My colleagues Sakshi and Gauri also helped me a lot in my coding skills development. Both Sakshi and Gauri always helped me when I got any query or error. I think I have learned so many learning as the internship goes on. I will suggest all other students join The Innovative Solution internship as of the experience I learned here from scratch to the final finished product.",
  // },

  // {
  //   id: 6,
  //   img: mansi,
  //   name: "Mansi Mahajan",
  //   designation: "Backend Web Developer (Intern)",
  //   desc: " I am very glad to tell you about my internship experience at The Innovative Solutions company. It was a great experience of learning and practical implementation of a live project.Currently, I am working as a Full stack web developer intern for the last 3 months got a lot of practical coding experience. I learned many skills like leadership skills, team management, time management, etc while leading my Goda project team. The flounder of our company Mr. Santosh Mundhe sir always guided me to improve my technical as well as soft skills and also directed me to correct track. My colleagues Sakshi and Gauri also helped me a lot in my coding skills development. Both Sakshi and Gauri always helped me when I got any query or error. I think I have learned so many things during this internship and also I am going to keep learning as the internship goes on. I will suggest all other students join The Innovative Solution internship as of the experience I learned here from scratch to the final finished product.",
  // },
];

const Feedbacks = () => {
  return (
    <>
      <div>
        <div className="text-center px-4">
          <h3 className="text-center mt-5">Our Team's Feedbacks </h3>
          <hr />
        </div>
        <Carousel
          showArrows={true}
          infiniteLoop={true}
          showThumbs={false}
          showStatus={false}
          autoPlay={true}
          interval={6100}
        >
          {data.map((item) => {
            return (
              <>
                <div>
                  <img src={item.img} />
                  <div className="myCarousel">
                    <br />
                    <h3>{item.name}</h3>
                    <h4>{item.designation}</h4>
                    <p>{item.desc}</p>
                  </div>
                </div>
              </>
            );
          })}

          {/* <div>
          <img src={sakshi} />
          <div className="myCarousel">
            <br />
            <h3>Sakshi Kadave</h3>
            <h4>Backend Web Developer </h4>
            <p>
              I am working as a backend end developer at the Innovative
              Solutions, and I have been with this company for 1 year now, My
              experience with this company has been like my second home. All the
              people around me in the company, especially Santosh sir, who
              raised me up in all things that I even had no idea about before my
              colleagues taught me well, make joining this company the best
              decision I have ever made.
            </p>
          </div>
        </div>

        <div>
          <img src={gaurav} />
          <div className="myCarousel">
            <br />
            <h3>Gaurav Lonari</h3>
            <h4>Fullstack Web Developer</h4>
            <p>
              I have been working as a Full Stack Developer Intern at The
              Innovative Solutions for almost 3 months now and I wanted to share
              my positive experience. The onboarding process, led by Mr. Nilesh,
              was smooth and made it easy for me to contribute to the company's
              objectives. I have been working on a project from scratch and it
              is almost ready as a prototype. My colleagues, Ms. Gauri, Ms.
              Sakshi, have been very collaborative and supportive in this
              process. Mr. Santosh has ensured that I have a comfortable work
              environment and access to various facilities for a great work-life
              balance. The team atmosphere is supportive and positive, which has
              enabled me to give my best effort. I am grateful for the
              opportunity and look forward to further growth with The Innovative
              Solutions.
            </p>
          </div>
        </div>

        <div>
          <img src={kunjal} />
          <div className="myCarousel">
            <br />
            <h3>Kunjal Pande</h3>
            <h4>Front Web Developer (Intern) </h4>
            <p>
              My name is Kunjal and I had the opportunity to go through a
              three-month Web Development internship at "Innovative Solutions".
              I must say this was an enriching experience for me as an intern.
              Since I got this opportunity, my goal for this short period was to
              get acquainted with the culture of the software firm, to learn as
              much as possible about the web development domain, to expand my
              knowledge, and to gain hands-on experience in projects. I got the
              opportunity to work as a team lead of interns. At the time of my
              internship, I gained precious experience, practical skills, and
              applied knowledge. I want to note the keen team at Innovative
              Solutions which openly accepts new people and is ready to help at
              any moment in time, I wish to say special thanks to Mr. Santosh
              Sir, Ms. Gauri Ma'am, and Sakshi Ma'am for guidance, support, and
              mentorship. I would like to thank my colleagues without exception
              for their excellent attitude, help, and incredible responsiveness.
              I will recall these months with the warmest thoughts!
            </p>
          </div>
        </div>

        <div>
          <img src={mansi} />
          <div className="myCarousel">
            <br />
            <h3>Mansi Mahajan</h3>
            <h4>Backend Web Developer (Intern)</h4>
            <p>
              I got to know about The innovative solutions from my seniors and I
              join the company as a backend developer intern . Joining The
              Innovative solutions was a perfect decision to develop myself.
              From day one, I was given meaningful work that challenged me and
              allowed me to apply the skills I learned in college. The team I
              worked with was incredibly supportive and provided me with
              mentorship and feedback that helped me grow and improve
              throughout the internship. The company culture is also great.
              Everyone is friendly and welcoming, and I always feel like I'm
              part of the team. The company have a fun and collaborative
              atmosphere that make it easy to work on projects together
              and share ideas. These not only help me develop new skills but
              also boost my confidence and show me that I'm capable of
              more than I thought.
            </p>
          </div>
        </div>

        <div>
          <img src={manish} />
          <div className="myCarousel">
            <br />
            <h3>Manish Karegaonkar</h3>
            <h4>Front-End Web Developer (Intern)</h4>
            <p>
              I am very glad to tell you about my internship experience at The
              Innovative Solutions company. It was a great experience of
              learning and practical implementation of a live project.
              Currently, I am working as a Full stack web developer intern for
              the last 3 months got a lot of practical coding experience. I
              learned many skills like leadership skills, team management, time
              management, etc while leading my Goda project team. The
              flounder of our company Mr. Santosh Mundhe sir always guided me to
              improve my technical as well as soft skills and also directed me
              to correct track. My colleagues Sakshi and Gauri also helped me a
              lot in my coding skills development. Both Sakshi and Gauri always
              helped me when I got any query or error. I think I have learned so
              many things during this internship and also I am going to keep
              learning as the internship goes on. I will suggest all other
              students join The Innovative Solution internship as of the
              experience I learned here from scratch to the final finished
              product.
            </p>
          </div>
        </div> */}
        </Carousel>
      </div>
      <Footer />
    </>
  );
};

export default Feedbacks;
